export {
  BOTServiceCategories,
  BOTFeaturedDeals,
  BOTFeaturedArticles,
  BOTServiceCategoryDetails,
  BOTServiceDetails
} from '../ServicePages'
